export const RENTAL_STATUS = {
  OFFLINE: 0,
  ONLINE: 1,
  UNFINISHED: 2,
};
